<template>
  <div class="mt-0 elegant-container">
    <v-dialog v-model="dialog.pembayaran"
      @keydown.esc="dialog.pembayaran = false"
      :fullscreen="dialog.fullscreen"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Pembayaran

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.pembayaran = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <!-- <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          <ValidationObserver 
            ref="form">
            <v-form>

              <ValidationProvider
                name="Metode Pembayaran" 
                rules="required" 
                v-slot="{ errors }">
                <div 
                  class="fs-15 label-input">
                  Metode Pembayaran
                </div>

                <v-autocomplete
                  v-on:keydown.enter.prevent="save()"
                              
                  filled
                  rounded
                  dense
                  solo

                  color="#718EBF"
                  placeholder="Metode Pembayaran"
                  v-model="form.payment_method"
                  :items="['Tunai','Transfer']"
                  
                  outlined
                  class="mt-4"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                </v-autocomplete>
              </ValidationProvider>

              <!-- <v-autocomplete
                v-model="form.payment_method"
                :items="['Tunai','Transfer']"
                
                label="Pilih Tipe Pembayaran"
                
                dense
                outlined
                hide-details
                style="width: 100%"
                class="mt-4"
                >
              </v-autocomplete> -->

              <div v-if="form.payment_method === 'Transfer'">
                <ValidationProvider
                  name="Pilih Bank" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input">
                    Pilih Bank
                  </div>

                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                                
                    filled
                    rounded
                    dense
                    solo

                    color="#718EBF"
                    item-text="name"
                    item-value="name"
                    placeholder="Pilih Bank"
                    v-model="form.bank"
                    :items="bank"
                    
                    outlined
                    return-object
                    class="mt-4"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                    <template v-slot:selection="{ item }">
                      <div
                        v-if="item" style="color: #718EBF">
                        {{ item.name }} ({{ item.rek_number }})
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.rek_number }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </div>

              <div class="mt-3">
                <div 
                  class="fs-15 label-input">
                  <!-- <span class="red--text">*</span> -->
                  Bukti Pembayaran
                </div>
                <uploadfolder
                  v-model="upload.payment_bukti_url" 
                  style="height: 250px; width: 250px">
                  <div 
                    slot="activator"
                    class="cursor-pointer">
                    <v-card 
                      flat
                      height="250"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <div v-if="form.payment_bukti_url.length < 1">
                        <v-icon v-if="!process.payment_bukti_url"
                          size="60" 
                          color="#718EBF">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </div>

                      <v-img v-else
                        contain
                        height="250"
                        :src="form.payment_bukti_url" 
                        :alt="form.payment_bukti_url"
                        class="text-center d-flex align-center">
                        <div 
                          class="d-flex aling-center justify-center" 
                          style="width: 100%; height: auto;">
                          <v-icon v-if="!process.payment_bukti_url"
                            size="60" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>

                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </div>
                      </v-img>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>
            </v-form>
          </ValidationObserver>


          <div v-if="message.error.length > 0"
            class="text-left mt-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Ya, {{ message.status }}
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
            :disabled="process.status"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.status"
    @keydown.esc="dialog.status = false"
    :fullscreen="dialog.fullscreen"
    width="500"
    persistent
    scrollable>
    <v-card 
      :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
      class="pa-8 pt-6">
      <v-card-title 
        class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
        
        Mengubah Status

        <v-spacer/>

        <!-- <v-icon 
          @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
          class="cursor-pointer mr-1"
          size="24"
          color="#718EBF">
          {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
        </v-icon>

        <v-icon 
          @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
          class="cursor-pointer"
          size="24"
          color="red">
          mdi-close-circle-outline
        </v-icon> -->

        <v-icon 
          @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
          class="cursor-pointer"
          size="18"
          color="#000000">
          mdi-close
        </v-icon>
      </v-card-title>
      
      <!-- <v-divider 
        class="mb-2"
        style="border-top: 2px dashed #e0e0e0;"/> -->

      <v-card-text 
        class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
        Apakah Anda yakin mengkonfirmasi pembayaran ini?


        <div v-if="message.error.length > 0"
          class="text-left mt-4">
          <div
            class="error--text d-flex align-start">
            <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>
      </v-card-text>


      <!-- <v-divider 
        class="mt-2"
        style="border-top: 2px dashed #e0e0e0;"/> -->

      <v-card-actions
        class="pa-0 pt-4">
        <v-spacer/>

        <v-btn
          rounded
          @click="saveApproval()"
          :loading="process.form"
          :disabled="process.form"
          width="190"
          height="45"
          elevation="0"
          color="#1814F3"
          class="fs-16 white--text text-capitalize border-radius">
          Ya, {{ message.status }}
        </v-btn>

        <!-- <v-btn
          rounded
          width="120"
          @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
          :disabled="process.status"
          outlined
          class="body-2 font-weight-bold text-capitalize red--text">
          Batal
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
    <v-dialog v-model="dialog.buktiPembayaran"
      @keydown.esc="dialog.buktiPembayaran = false"
      width="800"
      persistent
      scrollable>
      <v-card 
        style="border-radius: 8px;"
        class="pa-4">
        <v-card-title 
          class="d-flex align-center pa-0 pb-2 text-right popup-header fs-20 font-weight-bold">
          
          Bukti Pembayaran

          <v-spacer/>

          <v-icon 
            @click="dialog.buktiPembayaran = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-divider 
          class="mb-3"
          style="border-top: 1px dashed #e0e0e0;"/>

        <v-card-text class="text-center">
          <v-img
            :src="detail.payment_bukti_url"
            contain
            style="width: 100%; height: 500px;"
            alt="Bukti Pembayaran">
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Tambah Pembayaran -->
    <v-dialog v-model="dialog.tambahPembayaran"
      @keydown.esc="dialog.tambahPembayaran = false"
      max-width="760"
      persistent
      scrollable>
      <v-card 
        style="border-radius: 16px; overflow: hidden;"
        class="payment-form-dialog">
        <!-- Header dengan gradient -->
        <v-card-title 
          class="payment-form-header pa-4">
          <div class="d-flex align-center">
            <v-avatar size="36" color="white" class="mr-3">
              <v-icon color="#1814F3" size="18">mdi-cash-plus</v-icon>
            </v-avatar>
            <div>
              <div class="fs-16 white--text font-weight-bold" style="line-height: 1.5;">Tambah Pembayaran</div>
              <div class="fs-11 white--text" style="opacity: 0.9; line-height: 1.5;">
                Lengkapi informasi pembayaran untuk invoice ini
              </div>
            </div>
          </div>
          <v-spacer/>
          <v-btn
            @click="closeDialogTambahPembayaran()"
            icon
            small
            class="white--text">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Invoice Info Card -->
        <v-card-text class="pa-0">
          <div class="px-4 pt-3 pb-2">
            <!-- <v-card 
              flat
              style="border-radius: 6px; background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); border: 1px solid #E5E7EB;"
              class="mb-3">
              <v-card-text class="pa-3">
                <v-row align="center">
                  <v-col cols="12" md="6">
                    <div class="d-flex align-center mb-2">
                      <v-icon color="#1814F3" size="20" class="mr-2">mdi-file-document-outline</v-icon>
                      <div>
                        <div class="text-caption grey--text">No. Invoice</div>
                        <div class="text-body-1 font-weight-bold black--text">{{ detail.number || '-' }}</div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="d-flex align-center mb-2">
                      <v-icon color="#1814F3" size="20" class="mr-2">mdi-account</v-icon>
                      <div>
                        <div class="text-caption grey--text">Customer</div>
                        <div class="text-body-1 font-weight-bold black--text">{{ detail.customer_name || '-' }}</div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card> -->
          </div>

          <div class="px-4 pb-3">
            <ValidationObserver ref="formTambahPembayaran">
              <v-form>
                <!-- Section 1: Informasi Pembayaran -->
                <div class="form-section mb-4">
                  <div class="section-header mb-3">
                    <v-icon color="#1814F3" size="18" class="mr-2">mdi-information-outline</v-icon>
                    <span class="fs-15 font-weight-bold black--text">Informasi Pembayaran</span>
                  </div>
                  
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0">
                      <ValidationProvider
                        name="Total Dibayar" 
                        :rules="`required|max_value:${(((order_list.detail.reduce((acc, item) => acc + ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1))), 0)) - (order_list.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))), 0))) - (detail.total_paid*1))}|min_value:0`"
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-cash</v-icon>
                          Total Dibayar
                        </div>
                        <v-currency-field
                          v-model="formPembayaran.total_paid"
                          @input="recalculateSisaTagihan"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Masukkan total pembayaran"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          prefix="Rp"
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="12" md="6" class="pb-0">
                      <div class="fs-14 label-input font-weight-medium mb-2">
                        <v-icon size="16" color="#718EBF" class="mr-1">mdi-alert-circle</v-icon>
                        Sisa Tagihan
                      </div>
                      <v-text-field
                        :value="formatCurrency(formPembayaran.sisa_tagihan)"
                        readonly
                        filled
                        rounded
                        dense
                        solo
                        outlined
                        class="modern-input"
                        style="border-radius: 10px;"
                        hide-details>
                      </v-text-field>
                      <div class="text-caption grey--text mt-1">
                        {{ sisaTagihanDescription }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12" class="pb-0">
                      <ValidationProvider
                        name="Metode Pembayaran" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-credit-card</v-icon>
                          Metode Pembayaran
                        </div>
                        <v-autocomplete
                          v-model="formPembayaran.payment_method"
                          :items="[
                            { text: 'Transfer', value: 'transfer', icon: 'mdi-bank-transfer' },
                            { text: 'Tunai', value: 'tunai', icon: 'mdi-cash' },
                            { text: 'Giro', value: 'giro', icon: 'mdi-file-document-outline' }
                          ]"
                          item-text="text"
                          item-value="value"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Pilih metode pembayaran"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-icon size="18" class="mr-2" :color="getPaymentMethodColor(item.value)">
                                  {{ item.icon }}
                                </v-icon>
                                {{ item.text }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <template v-slot:selection="{ item }">
                            <div class="d-flex align-center">
                              <v-icon size="18" class="mr-2" :color="getPaymentMethodColor(item.value)">
                                {{ item.icon }}
                              </v-icon>
                              {{ item.text }}
                            </div>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </div>

                <!-- Section 2: Informasi Bank (jika transfer) -->
                <div v-if="formPembayaran.payment_method === 'transfer'" class="form-section mb-4">
                  <div class="section-header mb-3">
                    <v-icon color="#1814F3" size="18" class="mr-2">mdi-bank</v-icon>
                    <span class="fs-15 font-weight-bold black--text">Informasi Bank</span>
                  </div>
                  
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0">
                      <ValidationProvider
                        name="Nama Bank" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-bank</v-icon>
                          Nama Bank
                        </div>
                        <v-autocomplete
                          v-model="formPembayaran.bank_name"
                          :items="bank"
                          item-text="name"
                          item-value="name"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Pilih bank"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          @change="onBankChange"
                          style="border-radius: 10px;">
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="12" md="6" class="pb-0">
                      <ValidationProvider
                        name="Nomor Rekening" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-credit-card-outline</v-icon>
                          Nomor Rekening
                        </div>
                        <v-text-field
                          v-model="formPembayaran.rek_number"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Masukkan nomor rekening"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </div>

                <!-- Section 3: Bukti Pembayaran -->
                <div class="form-section mb-3">
                  <div class="section-header mb-3">
                    <v-icon color="#1814F3" size="18" class="mr-2">mdi-image</v-icon>
                    <span class="fs-15 font-weight-bold black--text">Bukti Pembayaran</span>
                  </div>
                  
                  <div class="upload-section">
                    <uploadfolder
                      v-model="uploadPembayaran.bukti_url" 
                      style="height: 180px; width: 100%;">
                      <div slot="activator" class="cursor-pointer">
                        <v-card 
                          flat
                          height="180"
                          class="d-flex align-center justify-center upload-card"
                          style="border-radius: 6px; border: 2px dashed #D1D5DB; background: #F9FAFB;">
                          <div v-if="!formPembayaran.bukti_url || formPembayaran.bukti_url.length < 1" class="text-center">
                            <v-icon v-if="!processPembayaran.bukti_url"
                              size="64" 
                              color="#718EBF"
                              class="mb-3">
                              mdi-cloud-upload-outline
                            </v-icon>
                            <v-progress-circular v-else
                              indeterminate
                              :color="set_color"
                              size="48">
                            </v-progress-circular>
                            <div v-if="!processPembayaran.bukti_url" class="text-body-2 grey--text mt-2">
                              Klik untuk upload bukti pembayaran
                            </div>
                          </div>
                          <v-img v-else
                            contain
                            height="180"
                            :src="formPembayaran.bukti_url" 
                            :alt="formPembayaran.bukti_url"
                            class="text-center d-flex align-center"
                            style="border-radius: 6px;">
                            <div class="overlay-upload">
                              <v-icon size="48" color="white">mdi-camera</v-icon>
                              <div class="text-body-2 white--text mt-2">Klik untuk ganti gambar</div>
                            </div>
                          </v-img>
                        </v-card>
                      </div>
                    </uploadfolder>
                  </div>
                </div>

                <!-- Section 4: Informasi Penerima -->
                <div class="form-section mb-2">
                  <div class="section-header mb-3">
                    <v-icon color="#1814F3" size="18" class="mr-2">mdi-account-check</v-icon>
                    <span class="fs-15 font-weight-bold black--text">Informasi Penerima</span>
                  </div>
                  
                  <v-row>
                    <v-col cols="12" md="12" class="pb-0">
                      <ValidationProvider
                        name="Nama Penerima" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-account</v-icon>
                          Nama Penerima
                        </div>
                        <v-autocomplete
                          v-model="formPembayaran.receipt_user_name"
                          :items="usersReceipt"
                          :item-text="item => `${item.name} - ${item.category_user_title}`"
                          item-value="id"
                          return-object
                          @change="onReceiptUserChange()"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Pilih nama penerima"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:selection="{ item }">
                            <div v-if="item" style="color: #000">
                              {{ item.name }} - {{ item.category_user_title }}
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.name }} - {{ item.category_user_title }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>

                    <!-- <v-col cols="12" md="6">
                      <div v-if="formPembayaran.receipt_user_name && formPembayaran.receipt_user_name.category_user_title" class="mt-4">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-tag</v-icon>
                          Kategori Penerima
                        </div>
                        <v-card 
                          flat
                          style="border-radius: 10px; background: #F0F4FF; border: 1px solid #E0E7FF;"
                          class="pa-3">
                          <div class="fs-15 font-weight-bold" style="color: #1814F3;">
                            {{ formPembayaran.receipt_user_name.category_user_title }}
                          </div>
                        </v-card>
                      </div>
                    </v-col> -->
                  </v-row>

                  <div v-if="!shouldHideReceiptFields">
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <ValidationProvider
                          name="Sudah Diterima" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-check-circle</v-icon>
                            Status Penerimaan
                          </div>
                          <v-autocomplete
                            v-model="formPembayaran.sudah_diterima"
                            :items="[
                              { text: 'Sudah Diterima', value: 'sudah', icon: 'mdi-check-circle', color: 'success' },
                              { text: 'Belum Diterima', value: 'belum', icon: 'mdi-clock-outline', color: 'warning' }
                            ]"
                            item-text="text"
                            item-value="value"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Pilih status"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <v-icon size="18" class="mr-2" :color="item.color">
                                    {{ item.icon }}
                                  </v-icon>
                                  {{ item.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                            <template v-slot:selection="{ item }">
                              <div class="d-flex align-center">
                                <v-icon size="18" class="mr-2" :color="item.color">
                                  {{ item.icon }}
                                </v-icon>
                                {{ item.text }}
                              </div>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="12" md="6" class="pb-0" v-if="formPembayaran.sudah_diterima === 'sudah'">
                        <ValidationProvider
                          name="Tanggal Diterima" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="fs-14 label-input font-weight-medium mb-2">
                            <v-icon size="16" color="#718EBF" class="mr-1">mdi-calendar</v-icon>
                            Tanggal Diterima
                          </div>
                          <v-text-field
                            v-model="formPembayaran.diterima_date"
                            type="date"
                            filled
                            rounded
                            dense
                            solo
                            outlined
                            placeholder="Pilih tanggal"
                            class="modern-input"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-form>
            </ValidationObserver>

            <!-- Error Message -->
            <div v-if="messagePembayaran.error.length > 0" class="px-4 pb-3">
              <v-alert
                type="error"
                dense
                outlined
                style="border-radius: 10px;">
                <div class="d-flex align-center">
                  <v-icon size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
                  <span>{{ messagePembayaran.error }}</span>
                </div>
              </v-alert>
            </div>
          </div>
        </v-card-text>

        <!-- Footer Actions -->
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer/>
          <v-btn
            @click="closeDialogTambahPembayaran()"
            outlined
            small
            height="38"
            style="border-radius: 8px; min-width: 110px;"
            class="mr-2">
            <v-icon left size="16">mdi-close</v-icon>
            Batal
          </v-btn>
          <v-btn
            @click="savePembayaran()"
            :loading="processPembayaran.form"
            :disabled="processPembayaran.form"
            small
            height="38"
            elevation="0"
            color="#1814F3"
            style="border-radius: 8px; min-width: 160px;"
            class="white--text font-weight-bold">
            <v-icon left size="16">mdi-content-save</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Update Pembayaran -->
    <v-dialog v-model="dialog.updatePembayaran"
      @keydown.esc="dialog.updatePembayaran = false"
      :max-width="dialogUpdateMaxWidth"
      persistent
      scrollable>
      <v-card 
        style="border-radius: 16px; overflow: hidden;"
        class="payment-form-dialog">
        <!-- Header dengan gradient -->
        <v-card-title 
          class="payment-form-header pa-4">
          <div class="d-flex align-center">
            <v-avatar size="36" color="white" class="mr-3">
              <v-icon color="#1814F3" size="18">mdi-cash-edit</v-icon>
            </v-avatar>
            <div>
              <div class="fs-16 white--text font-weight-bold" style="line-height: 1.5;">Update Pembayaran</div>
              <div class="fs-11 white--text" style="opacity: 0.9; line-height: 1.5;">
                Perbarui informasi pembayaran yang sudah ada
              </div>
            </div>
          </div>
          <v-spacer/>
          <v-btn
            @click="closeDialogUpdatePembayaran()"
            icon
            small
            class="white--text">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <div class="px-4 pt-3 pb-3">
            <ValidationObserver ref="formUpdatePembayaran">
              <v-form>
                <!-- Section 1: Informasi Pembayaran -->
                <div class="form-section mb-4">
                  <div class="section-header mb-3">
                    <v-icon color="#1814F3" size="18" class="mr-2">mdi-information-outline</v-icon>
                    <span class="fs-15 font-weight-bold black--text">Informasi Pembayaran</span>
                  </div>
                  
                  <v-row>
                    <v-col cols="12" md="12" class="pb-0">
                      <ValidationProvider
                        name="Total Dibayar" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-cash</v-icon>
                          Total Dibayar
                        </div>
                        <v-currency-field
                          v-model="formUpdatePembayaran.total_paid"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Masukkan total pembayaran"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          prefix="Rp"
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </div>

                <!-- Section 2: Informasi Penerima -->
                <div class="form-section mb-4">
                  <div class="section-header mb-3">
                    <v-icon color="#1814F3" size="18" class="mr-2">mdi-account</v-icon>
                    <span class="fs-15 font-weight-bold black--text">Informasi Penerima</span>
                  </div>
                  
                  <v-row>
                    <v-col cols="12" md="12" class="pb-0">
                      <ValidationProvider
                        name="Nama Penerima" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-account-circle</v-icon>
                          Nama Penerima
                        </div>
                        <v-autocomplete
                          v-model="formUpdatePembayaran.receipt_user_name"
                          :items="usersReceipt"
                          :item-text="item => `${item.name} - ${item.category_user_title}`"
                          item-value="id"
                          return-object
                          @change="onReceiptUserChangeUpdate()"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Pilih nama penerima"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:selection="{ item }">
                            <div v-if="item" class="d-flex align-center">
                              <v-icon size="18" color="#000" class="mr-2">mdi-account</v-icon>
                              <span style="color: #000">{{ item.name }} - {{ item.category_user_title }}</span>
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-icon size="18" color="#000" class="mr-2">mdi-account</v-icon>
                                {{ item.name }} - {{ item.category_user_title }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </div>

                <!-- Section 3: Tanggal Diterima -->
                <div class="form-section mb-4">
                  <div class="section-header mb-3">
                    <v-icon color="#1814F3" size="18" class="mr-2">mdi-calendar</v-icon>
                    <span class="fs-15 font-weight-bold black--text">Tanggal Diterima</span>
                  </div>
                  
                  <v-row>
                    <v-col cols="12" md="12" class="pb-0">
                      <ValidationProvider
                        name="Tanggal Diterima" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-14 label-input font-weight-medium mb-2">
                          <v-icon size="16" color="#718EBF" class="mr-1">mdi-calendar</v-icon>
                          Tanggal Diterima
                        </div>
                        <v-text-field
                          v-model="formUpdatePembayaran.diterima_date"
                          type="date"
                          filled
                          rounded
                          dense
                          solo
                          outlined
                          placeholder="Pilih tanggal diterima"
                          class="modern-input"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </ValidationObserver>

            <div v-if="messagePembayaran.error.length > 0" class="mt-4">
              <v-alert
                type="error"
                dense
                outlined
                class="mb-0">
                <div class="d-flex align-center">
                  <v-icon size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
                  <span>{{ messagePembayaran.error }}</span>
                </div>
              </v-alert>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer/>
          <v-btn
            @click="closeDialogUpdatePembayaran()"
            outlined
            small
            height="35"
            style="border-radius: 8px; min-width: 100px;"
            class="mr-2 text-capitalize">
            <v-icon left size="16">mdi-close</v-icon>
            Batal
          </v-btn>
          <v-btn
            @click="updatePembayaran()"
            :loading="processPembayaran.form"
            :disabled="processPembayaran.form"
            small
            height="35"
            elevation="0"
            color="#1814F3"
            style="border-radius: 8px; min-width: 140px;"
            class="white--text font-weight-bold text-capitalize">
            <v-icon left size="16">mdi-content-save</v-icon>
            Update Pembayaran
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog.ubahDiskon"
      @keydown.esc="closeDialogUbahDiskon()"
      max-width="580"
      persistent>
      <v-card style="border-radius: 18px; overflow: hidden; box-shadow: 0 18px 45px rgba(15, 23, 42, 0.14);">
        <div class="d-flex align-center justify-space-between px-5 py-4" style="background: linear-gradient(180deg, #F8FAFF 0%, #FFFFFF 100%); border-bottom: 1px solid #EEF2F7;">
          <div class="d-flex align-center">
            <div
              class="d-flex align-center justify-center mr-3"
              style="width: 42px; height: 42px; border-radius: 12px; background: rgba(24, 20, 243, 0.08);">
              <v-icon color="#2374e9">mdi-cash-edit</v-icon>
            </div>
            <div>
              <div class="fs-16 font-weight-bold" style="color: #1F2937; line-height: 1.2;">
                Ubah Nominal Diskon
              </div>
              <div class="fs-12" style="color: #6B7280;">
                Sesuaikan diskon promo dan strata untuk item ini
              </div>
            </div>
          </div>
          <v-btn
            icon
            small
            @click="closeDialogUbahDiskon()"
            style="background: #F8FAFC; border: 1px solid #E5E7EB;">
            <v-icon size="18" color="#64748B">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-5">
          <div
            v-if="formDiskon.product_name"
            class="px-4 py-3 mb-4"
            style="background: #F8FAFC; border: 1px solid #E9EEF5; border-radius: 14px;">
            <div class="fs-11 text-uppercase font-weight-bold mb-1" style="letter-spacing: 0.6px; color: #94A3B8;">
              Produk
            </div>
            <div class="fs-14 font-weight-medium" style="color: #1E293B;">
              {{ formDiskon.product_name }}
            </div>
          </div>

          <v-row dense class="mb-2">
            <v-col cols="12" sm="6">
              <div class="pa-4" style="background: #F8FAFC; border: 1px solid #E9EEF5; border-radius: 14px; height: 100%;">
                <div class="fs-12 font-weight-medium mb-1" style="color: #64748B;">
                  Total Diskon Promo Saat Ini
                </div>
                <div class="fs-16 font-weight-bold" style="color: #0F172A;">
                  {{ formDiskon.current_diskon_promo | price }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="pa-4" style="background: #F8FAFC; border: 1px solid #E9EEF5; border-radius: 14px; height: 100%;">
                <div class="fs-12 font-weight-medium mb-1" style="color: #64748B;">
                  Total Diskon Strata Saat Ini
                </div>
                <div class="fs-16 font-weight-bold" style="color: #0F172A;">
                  {{ formDiskon.current_diskon_strata | price }}
                </div>
              </div>
            </v-col>
          </v-row>

          <div class="fs-13 font-weight-medium mt-4 mb-2" style="color: #334155;">
            Total Diskon Promo Baru
          </div>
          <v-currency-field
            v-model="formDiskon.diskon_promo"
            dense
            outlined
            prefix="Rp"
            hide-details="auto"
            class="mb-4"
            style="border-radius: 12px;" />

          <div class="fs-13 font-weight-medium mb-2" style="color: #334155;">
            Total Diskon Strata Baru
          </div>
          <v-currency-field
            v-model="formDiskon.diskon_strata"
            dense
            outlined
            prefix="Rp"
            hide-details="auto"
            style="border-radius: 12px;" />

          <v-alert
            v-if="messageDiskon.error"
            type="error"
            dense
            outlined
            class="mt-4 mb-0"
            style="border-radius: 12px; background: #FEF2F2; border-color: #FECACA;">
            {{ messageDiskon.error }}
          </v-alert>
        </v-card-text>

        <div class="d-flex justify-end px-5 pb-5 pt-1">
          <v-btn
            outlined
            class="mr-2 text-capitalize font-weight-medium"
            style="border-radius: 10px; min-width: 110px; border-color: #D7DFEA; color: #475569;"
            @click="closeDialogUbahDiskon()">
            Batal
          </v-btn>
          <v-btn
            color="#2374e9"
            elevation="0"
            class="white--text text-capitalize font-weight-medium"
            style="border-radius: 10px; min-width: 150px;"
            :loading="process.updateDiskon"
            :disabled="process.updateDiskon"
            @click="updateDiskonOrderDetail()">
            Simpan Diskon
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          <div class="customer-page">
            <!-- Animated Background -->
            <div class="animated-bg">
              <div class="bg-shape shape-1"></div>
              <div class="bg-shape shape-2"></div>
              <div class="bg-shape shape-3"></div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
              <div class="header-content px-2">
                <div class="d-flex">
                  <h1>Detail Invoice Customer</h1>
                  <div v-if="Object.keys(detail).length > 0" class="header-badge ml-2" :style="`background: ${getStatusColor(detail.status)};`">
                    <v-icon size="14" color="white">mdi-file-document-outline</v-icon>
                    <span>{{ getStatusText(detail.status) }}</span>
                  </div>
                </div>
                <p v-if="Object.keys(detail).length > 0">Informasi lengkap invoice {{ detail.number }}</p>
                <p v-else>Memuat data invoice...</p>
              </div>
            </div>

            <!-- Main Content -->
            <div class="main-card">
              <!-- Loading State -->
              <div v-if="process.load" class="loading-container">
                <v-progress-circular
                  indeterminate
                  color="#00ADB5"
                  size="64"
                  width="6"
                  class="mb-4">
                </v-progress-circular>
                <div class="fs-16 font-weight-medium" style="color: #495057;">
                  Memuat Data Invoice...
                </div>
                <div class="fs-12 mt-2" style="color: #6c757d;">
                  Mohon tunggu sebentar
                </div>
              </div>

              <!-- Detail Information -->
              <div v-if="!process.load && Object.keys(detail).length > 0" class="form-step">
                <div class="step-header">
                  <div class="step-icon teal">
                    <v-icon color="white" size="28">mdi-file-document-outline</v-icon>
                  </div>
                  <div>
                    <h2>Informasi Invoice</h2>
                    <p>Detail lengkap invoice customer</p>
                  </div>
                </div>

                <!-- Info Grid -->
                <div class="info-grid">
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-account-circle</v-icon>
                      Nama Pemilik
                    </div>
                    <div class="info-value">
                      <a target="_blank" :href="`/customer/data/detail/${detail.customer_id}`" style="color: #00ADB5; text-decoration: none;">
                        {{ detail.customer_name }}
                      </a>
                    </div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-identifier</v-icon>
                      No. Invoice
                    </div>
                    <div class="info-value">{{ detail.number }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-file-document</v-icon>
                      No. BPB
                    </div>
                    <div class="info-value">{{ detail.bpb_number }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-shopping</v-icon>
                      No. Order
                    </div>
                    <div class="info-value">{{ detail.orders_number }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-information</v-icon>
                      Status
                    </div>
                    <div class="info-value">
                      <v-chip 
                        small
                        :color="getStatusColor(detail.status)"
                        text-color="white"
                        style="font-weight: 600;">
                        {{ getStatusText(detail.status) }}
                      </v-chip>
                    </div>
                  </div>
                  <div v-if="detail.paid_date !== ''" class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-credit-card</v-icon>
                      Metode Pembayaran
                    </div>
                    <div class="info-value text-capitalize">{{ detail.payment_method }}</div>
                  </div>
                  <div v-if="detail.paid_date !== ''" class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-calendar</v-icon>
                      Tanggal Pembayaran
                    </div>
                    <div class="info-value">{{ detail.paid_date | date }}</div>
                  </div>
                  <div v-if="detail.paid_date !== ''" class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-bank</v-icon>
                      Nama Bank
                    </div>
                    <div class="info-value text-capitalize">{{ detail.payment_bank_name == '' ? '-' : detail.payment_bank_name }}</div>
                  </div>
                  <div v-if="detail.paid_date !== ''" class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-numeric</v-icon>
                      No. Rekening
                    </div>
                    <div class="info-value text-capitalize">{{ detail.payment_rek_number == '' ? '-' : detail.payment_rek_number }}</div>
                  </div>
                  <div v-if="detail.paid_date !== ''" class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-account</v-icon>
                      Diterima Oleh
                    </div>
                    <div class="info-value">{{ detail.payment_user_name }}</div>
                  </div>
                  <div v-if="detail.paid_date !== '' && detail.payment_bukti_url !== ''" class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-image</v-icon>
                      Bukti Pembayaran
                    </div>
                    <div class="info-value">
                      <span class="cursor-pointer blue--text" @click="dialog.buktiPembayaran = true" style="text-decoration: underline;">
                        Klik untuk melihat bukti pembayaran
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Detail Produk -->
              <div v-if="!process.load && Object.keys(order_list).length > 0" class="form-step">
                <div class="step-header">
                  <div class="step-icon orange">
                    <v-icon color="white" size="28">mdi-format-list-bulleted</v-icon>
                  </div>
                  <div>
                    <h2>Detail Produk</h2>
                    <p>Daftar produk dalam invoice ini</p>
                  </div>
                </div>
                      <!-- <v-col cols="12" md="3">
                        <div>
                          <div class="fs-13 black--text" style="margin-bottom: 1px;">
                            Bukti Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            <v-img
                              :src="detail.payment_bukti_url"
                              style="width: 200px; height: 200px;"
                              contain
                              v-if="detail.payment_bukti_url !== ''"
                              class="d-flex align-center justify-center mt-2"
                              alt="Bukti Pembayaran">
                            </v-img>
                            <div v-if="detail.payment_bukti_url === ''">
                              -
                            </div>
                          </div>
                        </div>
                      </v-col> -->
                      <v-row>
                        <v-col cols="12">
                          <div class="font-weight-bold fs-13">
                            Customers :
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0 fs-13">
                          <div>
                            <div class="font-weight-bold">
                              {{ detail.store_name }}
                            </div>
                            <div class="text-lowercase">
                              {{ detail.customer_address }}, kel. {{ detail.customer_village_name }}, kec. {{ detail.customer_subdistrict_name }}
                              Kab. {{ detail.customer_city_name }} - {{ detail.customer_province_name }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end pt-0 fs-13">
                          <div>
                            <table style="width: 100%;">
                              <tr>
                                <td class="font-weight-bold">
                                  Nomer Order
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail.orders_number }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Nomer Surat Jalan
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail.delivery_number }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Tanggal Order
                                </td>
                                <td style="width: 80px" class="text-center">
                                  :
                                </td>
                                <td class="text-right">
                                  {{ detail.input_datetime | datetime }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Tanggal Jatuh Tempo
                                </td>
                                <td style="width: 80px" class="text-center">
                                  :
                                </td>
                                <td class="text-right">
                                  {{ detail.due_date | date }}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </v-col>
                        <v-col cols="12" class="my-8">
                          <div style="overflow: auto; " class="fs-13">
                            <table style="width: 100%;">
                              <tr>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Kode Barang
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Nama Barang
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Quantity
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Harga Per Unit
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Harga Bruto
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Diskon Promo
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Diskon Strata
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Harga Net. 
                                </td>
                              </tr>
                              <tr v-for="(item, index) in order_list.detail" :key="index">
                                <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                  {{ item.detail_varian_sku }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                  {{ item.detail_varian_name }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                  <!-- {{ `${item.bpb_detail_qty_dus_diterima*1}.${item.bpb_detail_qty_lusin_diterima*1}.${item.bpb_detail_qty_pcs_diterima*1}` }} -->
                                  {{ `${(item.detail_total_in_dus*1) === 1 ? 0 : (item.bpb_detail_qty_dus_diterima*1)}.${item.bpb_detail_qty_lusin_diterima*1}.${(item.detail_total_in_dus*1) === 1 ? (item.bpb_detail_qty_dus_diterima*1) : (item.bpb_detail_qty_pcs_diterima*1)}` }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  <!-- Rp {{ item.detail_price_per_pcs | number_dec }}  -->
                                  <span v-if="item.detail_qty_pcs !== 0">
                                    Rp. {{ item.detail_price_per_pcs | number_dec }}
                                  </span>
                                  <span v-else-if="item.detail_qty_lusin !== 0">
                                    Rp. {{ (item.detail_price_per_pcs*12) | number_dec }}
                                  </span>
                                  <span v-else-if="item.detail_qty_dus !== 0">
                                    Rp. {{ Math.round(item.detail_price_per_pcs*item.detail_total_in_dus) | number_dec }}
                                  </span>
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  <!-- <span v-if="item.detail_qty_pcs !== 0">{{ item.detail_price_pcs | price }}</span>
                                  <span v-else-if="item.detail_qty_lusin !== 0">{{ item.detail_price_lusin | price }}</span>
                                  <span v-else-if="item.bpb_detail_qty_dus_diterima !== 0">{{ item.detail_price_dus_new | price }}</span> -->
                                  {{ ((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                  <span class="cursor-pointer blue--text" style="text-decoration: underline;" @click="openDialogUbahDiskon(item)" v-if="detail.status === 'belum lunas' && (user.id === 1 || user.id === 10 || user.id === '1' || user.id === '10')">
                                    {{ (((item.detail_discount*1))) | price }}
                                  </span>
                                  <span v-else>
                                    {{ (((item.detail_discount*1))) | price }} 
                                  </span>
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                  <span class="cursor-pointer blue--text" style="text-decoration: underline;" @click="openDialogUbahDiskon(item)" v-if="detail.status === 'belum lunas' && (user.id === 1 || user.id === 10 || user.id === '1' || user.id === '10')">
                                    {{ (((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))) | price }}
                                  </span>
                                  <span v-else>
                                    {{ (((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))) | price }}
                                  </span>
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  {{ ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)) - ((((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))))) | price }}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                          <div class="fs-13">
                            <table style="width: 100%;">
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Harga Bruto
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  : 
                                </td>
                                <td class="pa-2 text-right">
                                  {{ order_list.detail.reduce((acc, item) => acc + ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1))), 0) | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Diskon 
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  :
                                </td>
                                <td class="pa-2 text-right">
                                    {{ order_list.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))), 0) | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Harga Net
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  :
                                </td>
                                <td class="pa-2 text-right">
                                  {{ ((order_list.detail.reduce((acc, item) => acc + ((((item.bpb_detail_qty_dus_diterima*1) === 0 ? 0 : (item.detail_price_dus_new*1)) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1))), 0)) - (order_list.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.bpb_detail_qty_dus_diterima*1))), 0))) | price }}

                                  <!-- <br></br> -->

                                  <!-- rumus baru: {{ hargaNet | price }} -->
                                </td>
                              </tr>
  
                            </table>
                          </div>
                        </v-col>
                      </v-row>
              </div>

                <!-- <v-card 
                  flat
                  class="mt-5"
                  style="border-radius: 25px;"
                  v-if="Object.keys(detail).length > 0 &&( detail.status == 'lunas' || detail.status == 'pengajuan' )">
  
                  <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                    <div class="fs-18 input-label">
                      Detail Pembayaran
                    </div>
                    <v-divider class="mt-4 mb-1"></v-divider>
                    <v-row>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Metode Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_method }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Nama Bank
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_bank_name == '' ? '-' : detail.payment_bank_name}}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Rekening
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_rek_number == '' ? '-' : detail.payment_rek_number}}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Tanggal Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.paid_date | date }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Pembayaran Diterima Oleh
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_user_name }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Bukti Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            <v-img
                              :src="detail.payment_bukti_url"
                              style="width: 300px; height: 300px;"
                              contain
                              v-if="detail.payment_bukti_url !== ''"
                              class="d-flex align-center justify-center mt-2"
                              alt="Bukti Pembayaran">
                            </v-img>
                            <div v-if="detail.payment_bukti_url === ''">
                              -
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card> -->

              <!-- Payment Section -->
              <div v-if="!process.load && Object.keys(detail).length > 0" class="form-step">
                <div class="step-header">
                  <div class="step-icon coral">
                    <v-icon color="white" size="28">mdi-cash-multiple</v-icon>
                  </div>
                  <div>
                    <h2>Data Pembayaran</h2>
                    <p>Riwayat dan detail pembayaran invoice</p>
                  </div>
                  <v-spacer></v-spacer>
                  <div v-if="Object.keys(detail).length > 0 && detail.status == 'belum lunas'">
                    <v-tooltip top v-if="adaPembayaranBelumDiterima">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-btn 
                            :loading="process.load"
                            :disabled="process.load || adaPembayaranBelumDiterima"
                            height="38"
                            small
                            elevation="0"
                            class="btn-tambah-pembayaran white--text text-capitalize"
                            style="background: #2374e9; border-radius: 8px; font-weight: 600; font-size: 12px; padding: 0 12px; transition: all 0.3s ease;">
                            <v-icon left size="18" class="mr-1">mdi-plus-circle</v-icon>
                            Tambah Pembayaran
                          </v-btn>
                        </span>
                      </template>
                      <span>Selesaikan pembayaran yang belum diterima terlebih dahulu</span>
                    </v-tooltip>
                    <v-btn 
                      v-else
                      @click="openDialogTambahPembayaran()"
                      :loading="process.load"
                      :disabled="process.load"
                      height="38"
                      small
                      elevation="0"
                      class="btn-tambah-pembayaran white--text text-capitalize"
                      style="background: #2374e9; border-radius: 8px; font-weight: 600; font-size: 12px; padding: 0 12px; box-shadow: 0 4px 12px #2374e9; transition: all 0.3s ease;">
                      <v-icon left size="18" class="mr-1">mdi-plus-circle</v-icon>
                      Tambah Pembayaran
                    </v-btn>
                  </div>
                </div>
    
                  <!-- Summary Cards -->
                  <v-row class="mb-4">
                    <v-col cols="12" sm="6" md="3">
                      <v-card 
                        elevation="0"
                        style="border-radius: 6px; border: 1px solid #E5E7EB; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);"
                        class="payment-summary-card">
                        <v-card-text class="pa-4 white--text">
                          <div class="d-flex justify-space-between align-center mb-2">
                            <div class="text-caption font-weight-medium opacity-90">Total Dibayar</div>
                            <v-icon color="white" size="28">mdi-cash-check</v-icon>
                          </div>
                          <div v-if="process.loadPembayaran" class="d-flex justify-center">
                            <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
                          </div>
                          <div v-else class="text-h6 font-weight-bold">
                            Rp {{ totalPembayaran | number_dec }}
                          </div>
                          <div class="text-caption opacity-75 mt-1">
                            {{ dataPembayaran.length }} transaksi
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
    
                    <v-col cols="12" sm="6" md="3">
                      <v-card 
                        elevation="0"
                        style="border-radius: 6px; border: 1px solid #E5E7EB; background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);"
                        class="payment-summary-card">
                        <v-card-text class="pa-4 white--text">
                          <div class="d-flex justify-space-between align-center mb-2">
                            <div class="text-caption font-weight-medium opacity-90">Sisa Tagihan</div>
                            <v-icon color="white" size="28">mdi-alert-circle</v-icon>
                          </div>
                          <div v-if="process.loadPembayaran" class="d-flex justify-center">
                            <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
                          </div>
                          <div v-else class="text-h6 font-weight-bold">
                            Rp {{ sisaTagihanTerakhir | number_dec }}
                          </div>
                          <div class="text-caption opacity-75 mt-1">
                            Tagihan terakhir
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
    
                    <v-col cols="12" sm="6" md="3">
                      <v-card 
                        elevation="0"
                        style="border-radius: 6px; border: 1px solid #E5E7EB; background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);"
                        class="payment-summary-card">
                        <v-card-text class="pa-4 white--text">
                          <div class="d-flex justify-space-between align-center mb-2">
                            <div class="text-caption font-weight-medium opacity-90">Sudah Diterima</div>
                            <v-icon color="white" size="28">mdi-check-circle</v-icon>
                          </div>
                          <div v-if="process.loadPembayaran" class="d-flex justify-center">
                            <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
                          </div>
                          <div v-else class="text-h6 font-weight-bold">
                            {{ jumlahSudahDiterima }}
                          </div>
                          <div class="text-caption opacity-75 mt-1">
                            dari {{ dataPembayaran.length }} pembayaran
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
    
                    <v-col cols="12" sm="6" md="3">
                      <v-card 
                        elevation="0"
                        style="border-radius: 6px; border: 1px solid #E5E7EB; background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);"
                        class="payment-summary-card">
                        <v-card-text class="pa-4 white--text">
                          <div class="d-flex justify-space-between align-center mb-2">
                            <div class="text-caption font-weight-medium opacity-90">Belum Diterima</div>
                            <v-icon color="white" size="28">mdi-clock-outline</v-icon>
                          </div>
                          <div v-if="process.loadPembayaran" class="d-flex justify-center">
                            <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
                          </div>
                          <div v-else class="text-h6 font-weight-bold">
                            {{ jumlahBelumDiterima }}
                          </div>
                          <div class="text-caption opacity-75 mt-1">
                            Menunggu konfirmasi
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
    
                <!-- Payment List -->
                <div class="payment-list-wrapper">
                  <v-card 
                    flat
                    style="border-radius: 6px; border: 1px solid #f6f7fa; overflow: hidden;"
                    class="payment-list-card">
                    <div v-if="process.loadPembayaran" class="text-center py-8">
                      <v-progress-circular
                        indeterminate
                        color="#1814F3"
                        size="40">
                      </v-progress-circular>
                      <div class="mt-4 text-body-2 grey--text">Memuat data pembayaran...</div>
                    </div>
    
                    <div v-else-if="dataPembayaran.length === 0" class="text-center py-8">
                      <v-icon size="64" color="grey lighten-1">mdi-cash-off</v-icon>
                      <div class="mt-4 text-h6 grey--text">Belum ada data pembayaran</div>
                      <div class="text-body-2 grey--text mt-2">Klik tombol "Tambah Pembayaran" untuk menambah data</div>
                    </div>
    
                    <div v-else class="payment-table-wrapper">
                      <table class="payment-table">
                        <thead>
                          <tr>
                            <th class="payment-th text-center payment-th-sticky">Aksi</th>
                            <th class="payment-th">Metode Pembayaran</th>
                            <th class="payment-th text-right">Total Dibayar</th>
                            <th class="payment-th text-right">Sisa Tagihan</th>
                            <!-- <th class="payment-th">Bank</th>
                            <th class="payment-th">No. Rekening</th> -->
                            <!-- <th class="payment-th">Kategori Penerima</th> -->
                            <th class="payment-th">Nama Penerima</th>
                            <th class="payment-th">Status</th>
                            <th class="payment-th">Tanggal Diterima</th>
                            <th class="payment-th">Tanggal Input</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr 
                            v-for="(item, index) in dataPembayaran" 
                            :key="index" 
                            class="payment-table-row"
                            :class="{ 'last-row': index === dataPembayaran.length - 1 }">
                            <td class="payment-td text-center payment-td-sticky">
                              <div class="d-flex align-center justify-center">
                                <v-tooltip top v-if="item.sudah_diterima === 'belum'">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="Object.keys(detail).length > 0 && detail.status == 'belum lunas' ? openDialogUpdatePembayaran(item) : null"
                                      x-small
                                      icon
                                      :disabled="Object.keys(detail).length > 0 && detail.status == 'lunas'"
                                      color="green"
                                      v-bind="attrs"
                                      v-on="on"
                                      class="mr-1"
                                      style="width: 30px; height: 30px;">
                                      <v-icon size="18">mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Edit Pembayaran</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.sudah_diterima === 'sudah'">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      x-small
                                      icon
                                      color="green"
                                      v-bind="attrs"
                                      disabled
                                      v-on="on"
                                      class="mr-1"
                                      style="width: 30px; height: 30px;">
                                      <v-icon size="18">mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Edit Pembayaran</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.bukti_url">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="dialog.buktiPembayaran = true; detail.payment_bukti_url = item.bukti_url"
                                      x-small
                                      icon
                                      color="info"
                                      v-bind="attrs"
                                      v-on="on"
                                      style="width: 30px; height: 30px;">
                                      <v-icon size="18">mdi-image-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Lihat Bukti Pembayaran</span>
                                </v-tooltip>
                              </div>
                            </td>
                            <td class="payment-td">
                              <div class="d-flex align-center">
                                <v-avatar 
                                  size="20" 
                                  :color="getPaymentMethodColor(item.payment_method)"
                                  class="mr-3">
                                  <v-icon color="white" size="14">
                                    {{ getPaymentMethodIcon(item.payment_method) }}
                                  </v-icon>
                                </v-avatar>
                                <div>
                                  <div class="fs-12 black--text">
                                    {{ item.payment_method | capitalize }}
                                  </div>
                                  <div v-if="item.bank_name || item.rek_number" class="text-caption grey--text mt-0">
                                    <span v-if="item.bank_name">{{ item.bank_name }}</span>
                                    <span v-if="item.bank_name && item.rek_number"> • </span>
                                    <span v-if="item.rek_number">{{ item.rek_number }}</span>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td class="payment-td text-right" style="min-width: 150px;">
                              <span class="payment-amount-primary">Rp {{ item.total_paid | number_dec }}</span>
                            </td>
                            <td class="payment-td text-right" style="min-width: 150px;">
                              <span class="payment-amount" :class="item.sisa_tagihan > 0 ? 'payment-amount-warning' : 'payment-amount-success'">
                                Rp {{ item.sisa_tagihan | number_dec }}
                              </span>
                            </td>
                            <!-- <td class="payment-td">
                              <span v-if="item.bank_name">{{ item.bank_name }}</span>
                              <span v-else class="grey--text">-</span>
                            </td>
                            <td class="payment-td">
                              <span v-if="item.rek_number">{{ item.rek_number }}</span>
                              <span v-else class="grey--text">-</span>
                            </td> -->
                            <!-- <td class="payment-td">
                              <v-chip
                                x-small
                                outlined
                                color="primary"
                                class="text-caption font-weight-medium"
                                style="border-width: 1.5px;">
                                {{ item.receipt_user_category | capitalize }}
                              </v-chip>
                            </td> -->
                            <td class="payment-td" style="min-width: 200px;">
                              <span class="payment-recipient-name">{{ item.receipt_user_name }} ({{ item.receipt_user_category | capitalize }})</span>
                            </td>
                            <td class="payment-td">
                              <v-chip
                                :color="item.sudah_diterima === 'sudah' ? 'success' : 'warning'"
                                small
                                text-color="white"
                                class="text-caption">
                                <v-icon left size="14">
                                  {{ item.sudah_diterima === 'sudah' ? 'mdi-check-circle' : 'mdi-clock-outline' }}
                                </v-icon>
                                {{ item.sudah_diterima === 'sudah' ? 'Sudah' : 'Belum' }}
                              </v-chip>
                            </td>
                            <td class="payment-td" style="min-width: 250px;">
                              <span v-if="item.diterima_date" class="payment-date">{{ item.diterima_date | dateFull }}</span>
                              <span v-else class="grey--text">-</span>
                            </td>
                            <td class="payment-td" style="min-width: 300px;">
                              <span v-if="item.input_datetime" class="payment-date">{{ item.input_datetime | dateFullTime }}</span>
                              <span v-else class="grey--text">-</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-card>
                </div>
              </div>

              <!-- Navigation Buttons -->
              <div class="form-nav">
                <v-btn
                  to="/kasir/customer"
                  :disabled="process.form"
                  depressed
                  large
                  class="elegant-btn-cancel"
                  style="min-width: 130px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 500; letter-spacing: 0.2px; background: #f5f7fa; color: #5C9EAD;">
                  <v-icon left size="16" class="mr-1">mdi-arrow-left</v-icon>
                  Kembali
                </v-btn>
              </div>
            </div>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service.js"
  import axios from "axios"
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false,
          pembayaran: false,
          buktiPembayaran: false,
          tambahPembayaran: false,
          updatePembayaran: false,
          ubahDiskon: false,
        },

        order_list: {},
        status: '',

        detail: {},

        rejected_reason: '',
        bank: [],

        form: {
          id: '',
          bpb_arr: [],
          payment_method: 'Tunai',
          payment_bank_name: '',
          payment_rek_number: '',
          payment_bukti_url: '',
        },
        category: [],
        branch: [],
        total_diskon: 0,

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          payment_bukti_url: null,
          image_url: null
        },
        total_nominal: 0,

        process: {
          form: false,

          load: false,

          image_url: false,
          payment_bukti_url: false,
          updateDiskon: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        },
        dataPembayaran: [],
        headersPembayaran: [
          { text: 'Total Dibayar', value: 'total_paid', sortable: false },
          { text: 'Sisa Tagihan', value: 'sisa_tagihan', sortable: false },
          { text: 'Metode Pembayaran', value: 'payment_method', sortable: false },
          { text: 'Bank', value: 'bank_name', sortable: false },
          { text: 'No. Rekening', value: 'rek_number', sortable: false },
          { text: 'Kategori Penerima', value: 'receipt_user_category', sortable: false },
          { text: 'Nama Penerima', value: 'receipt_user_name', sortable: false },
          { text: 'Sudah Diterima', value: 'sudah_diterima', sortable: false },
          { text: 'Tanggal Diterima', value: 'diterima_date', sortable: false },
          { text: 'Aksi', value: 'actions', sortable: false, align: 'center' },
        ],
        formPembayaran: {
          invoice_id: '',
          customer_id: '',
          store_id: '',
          total_paid: '',
          sisa_tagihan: '',
          receipt_user_name: '',
          payment_method: '',
          bank_name: '',
          rek_number: '',
          bukti_url: '',
          sudah_diterima: '',
          diterima_date: '',
        },
        formUpdatePembayaran: {
          payment_id: '',
          receipt_user_name: '',
          diterima_date: '',
          total_paid: '',
          sudah_diterima: 'belum',
        },
        usersReceipt: [],
        uploadPembayaran: {
          bukti_url: null,
        },
        processPembayaran: {
          form: false,
          loadPembayaran: false,
          bukti_url: false,
        },
        messagePembayaran: {
          error: '',
        },
        formDiskon: {
          id: '',
          diskon_promo: 0,
          diskon_strata: 0,
          current_diskon_promo: 0,
          current_diskon_strata: 0,
          product_name: '',
          qty_dus: 0
        },
        messageDiskon: {
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.payment_bukti_url': {
        handler: function () {
          if (this.upload.payment_bukti_url) {
            this.message.error = ''
            this.process.payment_bukti_url = this.upload.payment_bukti_url.process

            if (!this.process.payment_bukti_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.payment_bukti_url = this.upload.payment_bukti_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
      'uploadPembayaran.bukti_url': {
        handler: function () {
          if (this.uploadPembayaran.bukti_url) {
            this.messagePembayaran.error = ''
            this.processPembayaran.bukti_url = this.uploadPembayaran.bukti_url.process

            if (!this.processPembayaran.bukti_url) {
              this.formPembayaran.bukti_url = this.uploadPembayaran.bukti_url.fileuri
            }
          }
        },
        deep: true
      },
      'formPembayaran.total_paid': function () {
        this.recalculateSisaTagihan()
      },
      'formPembayaran.sudah_diterima': function () {
        this.recalculateSisaTagihan()
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      hargaNet() {
        const detailList = Array.isArray(this.order_list && this.order_list.detail) ? this.order_list.detail : []

        const totalHarga = detailList.reduce((acc, item) => {
          // Hitung ulang detail_price_dus_new dengan formula asli
          const hargaDusPerDus = Math.round((item.detail_price_per_pcs*1) * (item.detail_total_in_dus*1))
          const hargaDus = (item.bpb_detail_qty_dus_diterima*1) === 0 
            ? 0 
            : hargaDusPerDus * (item.bpb_detail_qty_dus_diterima*1)
          
          return acc + hargaDus + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)
        }, 0)
        
        const totalDiskon = detailList.reduce((acc, item) => {
          return acc + (item.detail_discount*1) + ((item.detail_strata_nominal*1) * (item.bpb_detail_qty_dus_diterima*1))
        }, 0)
        
        return totalHarga - totalDiskon
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      shouldHideReceiptFields () {
        const category = this.formPembayaran.receipt_user_name && this.formPembayaran.receipt_user_name.category_user_title
          ? this.formPembayaran.receipt_user_name.category_user_title
          : ''
        return category === 'Finance' || 
               category === 'Kasir' ||
               category === 'kasir'
      },
      shouldHideReceiptFieldsUpdate () {
        const category = this.formUpdatePembayaran.receipt_user_name && this.formUpdatePembayaran.receipt_user_name.category_user_title
          ? this.formUpdatePembayaran.receipt_user_name.category_user_title
          : ''
        return category === 'Finance' || 
               category === 'Kasir' ||
               category === 'kasir'
      },
      totalPembayaran () {
        // return this.dataPembayaran.reduce((sum, item) => sum + (parseFloat(item.total_paid) || 0), 0)
        return this.dataPembayaran.reduce((sum, item) => {
          return sum + (item.sudah_diterima === 'sudah' ? parseFloat(item.total_paid) || 0 : 0)
        }, 0)
      },
      sisaTagihanTerakhir () {
        if (this.dataPembayaran.length === 0) return 0
        const lastPayment = this.dataPembayaran[this.dataPembayaran.length - 1]
        return parseFloat(lastPayment.sisa_tagihan) || 0
      },
      jumlahSudahDiterima () {
        return this.dataPembayaran.filter(item => item.sudah_diterima === 'sudah').length
      },
      jumlahBelumDiterima () {
        return this.dataPembayaran.filter(item => item.sudah_diterima === 'belum').length
      },
      adaPembayaranBelumDiterima () {
        return this.dataPembayaran.some(item => item.sudah_diterima === 'belum')
      },
      baseSisaTagihan () {
        const invoiceTotal = parseFloat(this.hargaNet) || 0
        const alreadyPaid = parseFloat(this.detail.total_paid) || 0
        const base = invoiceTotal - alreadyPaid
        return base < 0 ? 0 : base
      },
      sisaTagihanDescription () {
        if (this.formPembayaran.sudah_diterima === 'sudah') {
          return `Perhitungan: (${this.formatCurrency(this.baseSisaTagihan)}) - Total Dibayar`
        }
        return `Sisa tagihan mengikuti nominal tagihan tersisa (${this.formatCurrency(this.baseSisaTagihan)})`
      },
      dialogUpdateMaxWidth () {
        return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm ? '760' : '500'
      }
    },
    mounted () {
      this.fetchDetail()
      this.fetchBank()
      this.fetchUsersReceipt()
    },
    methods: {
      getStatusColor (status) {
        const statusMap = {
          'belum lunas': '#EA5455',
          'lunas': '#00ADB5',
          'Set Order': '#FFD460',
          'pengajuan': '#F07B3F'
        }
        return statusMap[status] || '#393E46'
      },
      getStatusText (status) {
        const statusMap = {
          'belum lunas': 'Belum Lunas',
          'lunas': 'Lunas',
          'Set Order': 'Menunggu Pengiriman',
          'pengajuan': 'Pengajuan'
        }
        return statusMap[status] || status
      },
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/customer_invoice/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.bpb_arr = []
            this.detail = res.results.data
            this.fetchDetailOrder(this.detail.orders_id)
            this.recalculateSisaTagihan()
            this.fetchDataPembayaran()
            // res.results.data.bpb.map((item, index) => {
            //   this.form.bpb_arr.push({
            //     bpb_id: item.bpb_id,
            //     bpb_detail: item.detail
            //   })
            // })

            // this.form.bpb_arr.map((item, index) => {
            //   item.bpb_detail.map((items, indexs) => {
            //     items.bpb_detail_id = items.bpb_detail_id
            //     items.varian_name = items.varian_name
            //     items.varian_sku = items.varian_sku
            //     items.qty_pcs_diterima = items.qty_pcs_diterima
            //     items.qty_dus_diterima = items.qty_dus_diterima
            //     items.qty_lusin_diterima = items.qty_lusin_diterima
            //     items.qty_pcs_return = items.qty_pcs_return
            //     items.qty_dus_return = items.qty_dus_return
            //     items.qty_lusin_return = items.qty_lusin_return
            //   })
            // })
          }
          this.process.load = false
        })
      },
      async fetchBank () {
        // this.process.load = true
        let params = {
          limit: 10000000000000000000
        }

        await get('admin/bank/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.bank = res.results.data
          }
          // this.process.load = false
        })
      },
      async fetchDetailOrder (id) {
        this.process.load = true
        let params = {
          id: id,
          bpb_id: this.detail.bpb_id ? this.detail.bpb_id : ''
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data_detail = []
            res.results.data.detail.map((item, index) => {
              data_detail.push(
                {
                  ...item,
                  detail_price_dus_new: (Math.round(item.detail_price_per_pcs*item.detail_total_in_dus)*(item.bpb_detail_qty_dus_diterima*1))
                }
              )
            })
            this.order_list = res.results.data
            this.order_list.detail = data_detail
            // this.order_list.map((item, index) => {
            //   item.detail_price_pcs = item.qty_pcs_diterima*item.varian_pricelist_pcs_ppn
            //   item.detail_price_lusin = item.qty_lusin_diterima*item.varian_pricelist_pcs_ppn*12
            //   item.detail_price_dus = item.qty_dus_diterima*item.varian_pricelist_pcs_ppn*item.varian_total_in_dus
            // })
            // this.order_list.map((item, index) => {
            //   this.total_nominal += item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1
            // })
            // this.total_diskon = 0
            // this.order_list.map((item, index) => {
            //   item.detail_price_pcs = (item.qty_pcs_diterima*item.varian_pricelist_pcs_ppn) - item.varian_discount*1
            //   item.detail_price_lusin = (item.qty_lusin_diterima*item.varian_pricelist_pcs_ppn*12) - item.varian_discount*1
            //   item.detail_price_dus = (item.qty_dus_diterima*item.varian_pricelist_pcs_ppn*item.varian_total_in_dus) - item.varian_discount*1
            // })
            // this.order_list.map((item, index) => {
            //   this.total_nominal += item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1
            //   this.total_diskon += item.varian_discount*1
            // })
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        å
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      
    async saveApproval () {
      this.message.error = ''
      const isValid = true
      if (isValid) {
        

      this.process.form = true

      let url = 'admin/customer_invoice/update'

      await post(url, {
        data: {
          id: this.detail.id
        }
      }).then(response => {
        let res = response.data

        this.process.form = false

        if (res.status === 200) {

          this.dialog.status = false

          this.dialog.success = true
          
          // this.dialog.snackbar = true
          // this.message.success = res.message

          this.dialog.fullscreen = false

          this.fetchDetail()
        } else {
          this.message.error = res.message
        }
      })
        
      } else {
        // AUTO FOCUS ON TEXT-FIELD
        setTimeout(() => {
          const errors = Object.entries(this.$refs.form.errors)
            .map(([key, value]) => ({ key, value }))
            .filter(error => error['value'].length)
          this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 10)
      }
    },

      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate(),
        imgValid = true
        if (this.form.payment_bukti_url === '' || this.form.payment_bukti_url === null) {
          this.message.error = 'Bukti Pembayaran harus diisi'
          imgValid = false
        }
        // console.log(isValid, imgValid)
        if (isValid && imgValid) {
          

        this.process.form = true
        let form = {
          invoice_id: this.detail.id,
          payment_method: this.form.payment_method,
          payment_bank_name: this.form.payment_method === 'Tunai' ? '' : this.form.bank.name,
          payment_rek_number: this.form.payment_method === 'Tunai' ? '' : this.form.bank.rek_number,
          payment_bukti_url: this.form.payment_bukti_url
        }

        let url = 'admin/customer_invoice/payment'

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.pembayaran = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      },
      async fetchDataPembayaran () {
        this.processPembayaran.loadPembayaran = true
        let params = {
          invoice_id: this.detail.id,
          pagination_bool: false
        }

        await get('admin/customer_payment/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.dataPembayaran = res.results.data || []
          }
          this.processPembayaran.loadPembayaran = false
        })
        .catch(() => {
          this.processPembayaran.loadPembayaran = false
        })
      },
      async fetchUsersReceipt () {
        let params = {
          'category_user_id[in]': '8,11,14',
          limit: 1000000
        }

        await get('admin/user/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.usersReceipt = res.results.data || []
          }
        })
      },
      openDialogTambahPembayaran () {
        this.formPembayaran = {
          invoice_id: this.detail.id,
          customer_id: this.detail.customer_id,
          store_id: this.detail.store_id,
          total_paid: '',
          sisa_tagihan: '',
          receipt_user_name: '',
          payment_method: '',
          bank_name: '',
          rek_number: '',
          bukti_url: '',
          sudah_diterima: '',
          diterima_date: '',
        }
        this.messagePembayaran.error = ''
        this.dialog.tambahPembayaran = true
        this.recalculateSisaTagihan()
      },
      closeDialogTambahPembayaran () {
        this.dialog.tambahPembayaran = false
        this.messagePembayaran.error = ''
        if (this.$refs.formTambahPembayaran) {
          this.$refs.formTambahPembayaran.reset()
        }
      },
      onReceiptUserChange () {
        // Set / reset status penerimaan berdasarkan kategori user yang dipilih
        if (this.formPembayaran.receipt_user_name && this.formPembayaran.receipt_user_name.category_user_title) {
          if (this.shouldHideReceiptFields) {
            // Finance / Kasir -> auto sudah diterima hari ini
            this.formPembayaran.sudah_diterima = 'sudah'
            this.formPembayaran.diterima_date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
          } else {
            // Selain itu -> reset kembali ke kosong
            this.formPembayaran.sudah_diterima = ''
            this.formPembayaran.diterima_date = ''
          }
        } else {
          // Jika tidak ada user terpilih, reset juga
          this.formPembayaran.sudah_diterima = ''
          this.formPembayaran.diterima_date = ''
        }
        this.recalculateSisaTagihan()
      },
      onReceiptUserChangeUpdate () {
        // Set tanggal diterima otomatis jika Finance/Kasir
        if (this.formUpdatePembayaran.receipt_user_name && this.formUpdatePembayaran.receipt_user_name.category_user_title) {
          if (this.shouldHideReceiptFieldsUpdate) {
            // Finance / Kasir -> auto tanggal hari ini
            this.formUpdatePembayaran.diterima_date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
          }
        }
      },
      onBankChange () {
        // Auto-fill nomor rekening ketika bank dipilih
        if (this.formPembayaran.bank_name && this.bank && this.bank.length > 0) {
          const selectedBank = this.bank.find(b => b.name === this.formPembayaran.bank_name)
          if (selectedBank && selectedBank.rek_number) {
            this.formPembayaran.rek_number = selectedBank.rek_number
          }
        }
      },
      async savePembayaran () {
        this.messagePembayaran.error = ''
        const isValid = await this.$refs.formTambahPembayaran.validate()
        
        if (!isValid) {
          return
        }

        if (!this.formPembayaran.bukti_url || this.formPembayaran.bukti_url === '') {
          this.messagePembayaran.error = 'Bukti Pembayaran harus diisi'
          return
        }

        // Set default values jika Finance atau Kasir
        if (this.shouldHideReceiptFields) {
          this.formPembayaran.sudah_diterima = 'sudah'
          this.formPembayaran.diterima_date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        }

        this.processPembayaran.form = true

        let formData = new FormData()
        formData.append('invoice_id', this.formPembayaran.invoice_id)
        formData.append('customer_id', this.formPembayaran.customer_id)
        formData.append('store_id', this.formPembayaran.store_id)
        formData.append('total_paid', this.formPembayaran.total_paid)
        formData.append('sisa_tagihan', this.formPembayaran.sisa_tagihan)
        // Kategori penerima diambil dari category_user_title pada user yang dipilih
        const receiptUserObj = this.formPembayaran.receipt_user_name
        formData.append('receipt_user_category', receiptUserObj && receiptUserObj.category_user_title ? receiptUserObj.category_user_title : '')
        formData.append('receipt_user_name', receiptUserObj && receiptUserObj.name ? receiptUserObj.name : '')
        formData.append('payment_method', this.formPembayaran.payment_method)
        if (this.formPembayaran.payment_method === 'transfer') {
          formData.append('bank_name', this.formPembayaran.bank_name)
          formData.append('rek_number', this.formPembayaran.rek_number)
        }
        formData.append('bukti_url', this.formPembayaran.bukti_url)
        formData.append('sudah_diterima', this.formPembayaran.sudah_diterima)
        formData.append('diterima_date', this.formPembayaran.diterima_date)

        // Send FormData using axios directly
        const { VUE_APP_API_URL, VUE_APP_XAUTH } = process.env
        const bearerToken = TokenService.getToken()

        await axios.post(`${VUE_APP_API_URL}admin/customer_payment/add`, formData, {
          headers: {
            'Authorization': `${VUE_APP_XAUTH} ${bearerToken}`,
            'token': bearerToken,
            'Accept': 'application/json'
          }
        }).then(response => {
          let res = response.data

          this.processPembayaran.form = false

          if (res.status === 200) {
            this.closeDialogTambahPembayaran()
            this.fetchDataPembayaran()
            this.fetchDetail()
          } else {
            this.messagePembayaran.error = res.message
          }
        })
        .catch(error => {
          this.processPembayaran.form = false
          if (error.data && error.data.message) {
            this.messagePembayaran.error = error.data.message
          } else {
            this.messagePembayaran.error = 'Terjadi kesalahan saat menyimpan data'
          }
        })
      },
      recalculateSisaTagihan () {
        if (!this.formPembayaran) return
        const base = this.baseSisaTagihan
        const totalPaidInput = parseFloat(this.formPembayaran.total_paid) || 0
        // Jika input kurang dari 0, tidak perlu dihitung (tetap sama dengan base)
        if (totalPaidInput < 0) {
          this.formPembayaran.sisa_tagihan = base
          return
        }
        // Sisa tagihan langsung berkurang ketika total dibayar diisi
        let sisa = base - totalPaidInput
        if (sisa < 0) sisa = 0
        this.formPembayaran.sisa_tagihan = sisa
      },
      formatCurrency (value) {
        const number = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
        return `Rp ${number.toLocaleString('id-ID')}`
      },
      openDialogUpdatePembayaran (item) {
        // Find user object from usersReceipt
        let userObj = this.usersReceipt.find(u => u.name === item.receipt_user_name)
        
        this.formUpdatePembayaran = {
          payment_id: item.id,
          receipt_user_name: userObj || item.receipt_user_name || '',
          diterima_date: item.diterima_date || '',
          total_paid: item.total_paid*1 || '',
        }
        this.messagePembayaran.error = ''
        this.dialog.updatePembayaran = true
      },
      closeDialogUpdatePembayaran () {
        this.dialog.updatePembayaran = false
        this.messagePembayaran.error = ''
        if (this.$refs.formUpdatePembayaran) {
          this.$refs.formUpdatePembayaran.reset()
        }
      },
      async updatePembayaran () {
        this.messagePembayaran.error = ''
        const isValid = await this.$refs.formUpdatePembayaran.validate()
        
        if (!isValid) {
          return
        }

        this.processPembayaran.form = true

        let formData = new FormData()
        formData.append('payment_id', this.formUpdatePembayaran.payment_id)
        // Kategori penerima diambil dari category_user_title pada user yang dipilih
        const receiptUserUpdateObj = this.formUpdatePembayaran.receipt_user_name
        formData.append('receipt_user_category', receiptUserUpdateObj && receiptUserUpdateObj.category_user_title ? receiptUserUpdateObj.category_user_title : '')
        formData.append('receipt_user_name', receiptUserUpdateObj && receiptUserUpdateObj.name ? receiptUserUpdateObj.name : '')
        formData.append('diterima_date', this.formUpdatePembayaran.diterima_date)
        formData.append('total_paid', this.formUpdatePembayaran.total_paid)

        // Send FormData using axios directly
        const { VUE_APP_API_URL, VUE_APP_XAUTH } = process.env
        const bearerToken = TokenService.getToken()

        await axios.post(`${VUE_APP_API_URL}admin/customer_payment/update`, formData, {
          headers: {
            'Authorization': `${VUE_APP_XAUTH} ${bearerToken}`,
            'token': bearerToken,
            'Accept': 'application/json'
          }
        }).then(response => {
          let res = response.data

          this.processPembayaran.form = false

          if (res.status === 200) {
            this.closeDialogUpdatePembayaran()
            this.fetchDataPembayaran()
            this.fetchDetail()
          } else {
            this.messagePembayaran.error = res.message
          }
        })
        .catch(error => {
          this.processPembayaran.form = false
          if (error.data && error.data.message) {
            this.messagePembayaran.error = error.data.message
          } else {
            this.messagePembayaran.error = 'Terjadi kesalahan saat mengupdate data'
          }
        })
      },
      getPaymentMethodIcon (method) {
        const icons = {
          'transfer': 'mdi-bank-transfer',
          'tunai': 'mdi-cash',
          'giro': 'mdi-file-document-outline'
        }
        return icons[method?.toLowerCase()] || 'mdi-cash-multiple'
      },
      getPaymentMethodColor (method) {
        const colors = {
          'transfer': '#3b82f6',
          'tunai': '#10b981',
          'giro': '#8b5cf6'
        }
        return colors[method?.toLowerCase()] || '#6b7280'
      },
      openDialogUbahDiskon (item) {
        const qtyDus = item && item.bpb_detail_qty_dus_diterima ? (item.bpb_detail_qty_dus_diterima * 1) : 0
        const currentDiskonPromo = item && item.detail_discount ? (item.detail_discount * 1) : 0
        const currentDiskonStrata = item && item.detail_strata_nominal ? ((item.detail_strata_nominal * 1) * qtyDus) : 0

        console.log(this.formDiskon)

        this.formDiskon = {
          id: item.orders_detail_id,
          diskon_promo: currentDiskonPromo,
          diskon_strata: currentDiskonStrata,
          current_diskon_promo: currentDiskonPromo,
          current_diskon_strata: currentDiskonStrata,
          product_name: item.detail_varian_name || item.detail_varian_sku || '',
          qty_dus: qtyDus
        }
        this.messageDiskon.error = ''
        this.dialog.ubahDiskon = true
      },
      closeDialogUbahDiskon () {
        this.dialog.ubahDiskon = false
        this.messageDiskon.error = ''
      },
      async updateDiskonOrderDetail () {
        this.messageDiskon.error = ''
        if (!this.formDiskon.id) {
          this.messageDiskon.error = 'ID Order Detail tidak ditemukan'
          return
        }

        this.process.updateDiskon = true
        const url = 'admin/order/update_diskon'
        await post(url, {
          data: {
            id: this.formDiskon.id,
            diskon_promo: (this.formDiskon.diskon_promo * 1) || 0,
            diskon_strata: ((this.formDiskon.diskon_strata * 1) / this.formDiskon.qty_dus) || 0
          }
        }).then((response) => {
          const res = response.data
          this.process.updateDiskon = false

          if (res.status === 200) {
            this.closeDialogUbahDiskon()
            this.fetchDetailOrder(this.detail.orders_id)
          } else {
            this.messageDiskon.error = res.message
          }
        }).catch((error) => {
          this.process.updateDiskon = false
          this.messageDiskon.error = error?.response?.data?.message || 'Terjadi kesalahan saat mengubah diskon'
        })
      }
    },
    filters: {
      capitalize (value) {
        if (!value) return ''
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    }
  }
</script>

<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.payment-summary-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.payment-summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.payment-list-card {
  overflow: hidden;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important; */
  background: #FFFFFF;
}

.payment-table-wrapper {
  overflow-x: auto;
  overflow-y: auto;
  width: 100%;
  max-height: 400px;
  min-height: 400px;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.payment-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #FFFFFF;
  min-width: 100%;
}

.payment-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #FFFFFF;
}

.payment-table thead tr {
  background: #F8F9FA;
}

.payment-th {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #475569 !important;
  padding: 10px 12px !important;
  text-align: left !important;
  background: #f8fafc !important;
  border-bottom: 1px solid #f6f7fa !important;
  white-space: nowrap;
  position: relative;
  text-transform: capitalize;
  letter-spacing: 0.5px;
  font-size: 12px !important;
}

/* .payment-th:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  height: 60%;
  width: 1px;
  background: #f6f7fa;
} */

.payment-th.text-right {
  text-align: right !important;
}

.payment-th.text-center {
  text-align: center !important;
}

.payment-th-sticky {
  position: sticky !important;
  left: 0 !important;
  z-index: 12 !important;
  background: #f8fafc !important;
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.payment-table thead tr .payment-th-sticky {
  background: #F8F9FA !important;
}

.payment-td {
  font-size: 12px !important;
  color: #334155 !important;
  padding: 8px 12px !important;
  border-bottom: 1px solid #F1F5F9 !important;
  vertical-align: middle;
}

.payment-td-sticky {
  position: sticky !important;
  left: 0 !important;
  z-index: 11 !important;
  /* box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05); */
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.payment-table tbody tr:hover .payment-td-sticky {
  background: #F8FAFC !important;
}

.payment-td.text-right {
  text-align: right !important;
}

.payment-td.text-center {
  text-align: center !important;
}

.payment-table tbody tr {
  transition: all 0.2s ease;
}

.payment-table tbody tr:nth-child(odd) {
  background: #FFFFFF;
}

.payment-table tbody tr:nth-child(odd) .payment-td {
  background: #FFFFFF;
}

.payment-table tbody tr:nth-child(odd) .payment-td-sticky {
  background: #FFFFFF !important;
}

.payment-table tbody tr:nth-child(even) {
  background: #f9fafc;
}

.payment-table tbody tr:nth-child(even) .payment-td {
  background: #f9fafc;
}

.payment-table tbody tr:nth-child(even) .payment-td-sticky {
  background: #f9fafc !important;
}

.payment-table tbody tr:hover {
  background-color: #F8FAFC !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.payment-table tbody tr:hover .payment-td {
  background-color: #F8FAFC !important;
}

.payment-table tbody tr:hover .payment-td-sticky {
  background-color: #F8FAFC !important;
}

.payment-table tbody tr.last-row .payment-td {
  border-bottom: none !important;
}

.payment-amount {
  /* font-weight: 600; */
  font-size: 12px;
}

.payment-amount-primary {
  color: #000;
  /* font-weight: 600; */
  font-size: 12px;
}

.payment-amount-warning {
  color: #000;
}

.payment-amount-success {
  color: #000;
}

.payment-recipient-name {
  font-weight: 500;
  color: #1E293B;
}

.payment-date {
  color: #000;
  font-size: 13px;
}

.opacity-90 {
  opacity: 0.9;
}

.opacity-75 {
  opacity: 0.75;
}

/* Payment Form Dialog Styles */
.payment-form-dialog {
  overflow: hidden;
}

.payment-form-header {
  background: linear-gradient(135deg, #1814F3 0%, #667eea 100%);
  color: white;
}

.form-section {
  background: #FAFAFA;
  border-radius: 6px;
  padding: 16px;
  border: 1px solid #E5E7EB;
}

.section-header {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #E5E7EB;
}

.upload-card {
  position: relative;
  transition: all 0.3s ease;
}

.upload-card:hover {
  border-color: #1814F3 !important;
  background: #F0F4FF !important;
}

.overlay-upload {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(24, 20, 243, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 6px;
}

.upload-card:hover .overlay-upload {
  opacity: 1;
}

.modern-input >>> .v-input__slot {
  background: white !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.modern-input >>> .v-input__slot:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
}

.modern-input >>> .v-input__slot:focus-within {
  box-shadow: 0 0 0 2px rgba(24, 20, 243, 0.2) !important;
}

.btn-tambah-pembayaran {
  transition: all 0.3s ease !important;
}

.btn-tambah-pembayaran:hover:not(:disabled) {
  background: #2374e9 !important;
  box-shadow: 0 6px 20px #2374e9 !important;
  transform: translateY(-2px);
}

.btn-tambah-pembayaran:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px #2374e9 !important;
}

.btn-tambah-pembayaran:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-tambah-pembayaran .v-icon {
  transition: transform 0.3s ease;
}

.btn-tambah-pembayaran:hover:not(:disabled) .v-icon {
  transform: scale(1.1) rotate(90deg);
}

.payment-header-content {
  flex: 1;
}

.payment-header-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 4px 12px rgba(79, 172, 254, 0.3); */
  transition: all 0.3s ease;
}

.payment-header-icon-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 172, 254, 0.4);
}

.payment-header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1E293B;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.payment-header-subtitle {
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
  margin-top: 4px;
}
</style>

<style scoped>
/* Elegant Container */
.elegant-container {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
}

/* Customer Page */
.customer-page {
  position: relative;
  padding: 18px;
  padding-top: 36px;
  min-height: 100%;
}

/* Animated Background */
.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.6;
  animation: float 20s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  top: -100px;
  right: -50px;
  filter: blur(60px);
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
  bottom: 100px;
  left: -50px;
  filter: blur(50px);
  animation-delay: -5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  top: 50%;
  right: 20%;
  filter: blur(40px);
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(20px) rotate(-5deg); }
}

/* Page Header */
.page-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
}

.header-content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
  letter-spacing: -0.5px;
}

.header-content p {
  font-size: 14px;
  color: #393E46;
  margin: 0;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Main Card */
.main-card {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
  border: 1px solid rgba(238, 238, 238, 0.6);
  overflow: hidden;
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  min-height: 400px;
}

/* Form Step */
.form-step {
  padding: 24px;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f8f9fa;
}

.step-icon {
  width: 42px;
  height: 42px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-icon.teal {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  box-shadow: 0 8px 20px rgba(0, 173, 181, 0.3);
}

.step-icon.coral {
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  box-shadow: 0 8px 20px rgba(234, 84, 85, 0.3);
}

.step-icon.orange {
  background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%);
  box-shadow: 0 8px 20px rgba(240, 123, 63, 0.3);
}

.step-icon.yellow {
  background: linear-gradient(135deg, #FFD460 0%, #FFD460 100%);
  box-shadow: 0 8px 20px rgba(255, 212, 96, 0.3);
}

.step-header h2 {
  font-size: 14px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.step-header p {
  font-size: 12px;
  color: #393E46;
  margin: 0;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.info-card.full-width {
  grid-column: span 3;
}

.info-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e8eaed;
  transition: all 0.3s ease;
}

.info-card:hover {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.info-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #222831;
  word-break: break-word;
}

/* Form Navigation */
.form-nav {
  display: flex;
  align-items: center;
  padding: 0px 32px;
  padding-bottom: 24px !important;
  background: transparent;
  justify-content: end;
}

/* Responsive */
@media (max-width: 960px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .info-card.full-width {
    grid-column: span 1;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 600px) {
  .customer-page {
    padding: 16px;
  }
  
  .header-content h1 {
    font-size: 22px;
  }
  
  .form-step {
    padding: 18px;
  }
  
  .bg-shape {
    opacity: 0.3;
  }
}
</style>